import { render, staticRenderFns } from "./DomainSettingsPanel.vue?vue&type=template&id=70404d74&scoped=true"
import script from "./DomainSettingsPanel.vue?vue&type=script&lang=js"
export * from "./DomainSettingsPanel.vue?vue&type=script&lang=js"
import style0 from "./DomainSettingsPanel.vue?vue&type=style&index=0&id=70404d74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70404d74",
  null
  
)

export default component.exports